if (!customElements.get('pickup-availability')) {

  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {

    constructor() {

      super();



      this.onClickRefreshList = this.onClickRefreshList.bind(this);

      this.errorHtml = this.querySelector('template')?.content.firstElementChild?.cloneNode(true);

      if(!this.hasAttribute('available')) return;

      this.fetchAvailability(this.dataset.variantId);

    }



    fetchAvailability(variantId) {

      this.dataset.variantId = String(variantId);

      let rootUrl = this.dataset.rootUrl || '/';

      if (!rootUrl.endsWith("/")) {

        rootUrl = rootUrl + "/";

      }

      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;



      fetch(variantSectionUrl)

        .then(response => response.text())

        .then(text => {

          if (this.dataset.variantId !== String(variantId)) return;

          const sectionInnerHTML = new DOMParser()

            .parseFromString(text, 'text/html')

            .querySelector('.shopify-section');

          this.renderPreview(sectionInnerHTML);

        })

        .catch(e => {

          if (this.dataset.variantId !== String(variantId)) return;

          const button = this.querySelector('button');

          if (button) button.removeEventListener('click', this.onClickRefreshList);

          this.renderError();

        });

    }



    onClickRefreshList(evt) {

      this.fetchAvailability(this.dataset.variantId);

    }



    renderError() {

      this.innerHTML = '';

      if (this.errorHtml) this.appendChild(this.errorHtml.cloneNode(true));



      this.querySelector('button')?.addEventListener('click', this.onClickRefreshList);

    }



    renderPreview(sectionInnerHTML) {

      const drawer = document.querySelector('pickup-availability-drawer');

      if (drawer) drawer.remove();

      if (!sectionInnerHTML?.querySelector('pickup-availability-preview')) {

        this.innerHTML = "";

        this.removeAttribute('available');

        return;

      }



      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;

      this.setAttribute('available', '');



      const newDrawer = sectionInnerHTML.querySelector('pickup-availability-drawer');

      if (newDrawer) document.body.appendChild(newDrawer);



      const button = this.querySelector('button');

      if (button) button.addEventListener('click', (evt) => {

        document.querySelector('pickup-availability-drawer')?.show(evt.target);

      });

    }

  });

}



if (!customElements.get('pickup-availability-drawer')) {

  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {

    constructor() {

      super();



      this.onBodyClick = this.handleBodyClick.bind(this);



      this.querySelector('button')?.addEventListener('click', () => {

        this.hide();

      });



      this.addEventListener('keyup', (event) => {

        if(event.code.toUpperCase() === 'ESCAPE') this.hide();

      });

    }



    handleBodyClick(evt) {

      const target = evt.target;

      

      //

      console.log(target.className)

      

      if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer' || target.className === "popup-modal") {

        this.hide();

      }

    }



    hide() {

      this.removeAttribute('open');

      document.body.removeEventListener('click', this.onBodyClick);

      document.body.classList.remove('overflow-hidden');

      removeTrapFocus(this.focusElement);

    }



    show(focusElement) {

      this.focusElement = focusElement;

      this.setAttribute('open', '');

      document.body.addEventListener('click', this.onBodyClick);

      document.body.classList.add('overflow-hidden');

      trapFocus(this);

    }

  });

}



